/**
 * InflammationTwinPage — iter629 — Възпалителен близнак (13-ти).
 * Read-only — данни идват от Lab Twin PDF import (hsCRP) + хранителния twin.
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { useTheme } from "@/theme/ThemeContext";
import { Button } from "@/components/ui/button";
import { Loader2, ArrowLeft, Flame } from "lucide-react";
import { twinLabel } from "@/lib/twinCatalog";

import { MobileTopBar } from "@/components/MobileTopBar";
export default function InflammationTwinPage() {
  const { API } = useAuth();
  const { isDark } = useTheme();
  const navigate = useNavigate();
  const [snap, setSnap] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/inflammation-twin/snapshot`).then(({ data }) => setSnap(data)).finally(() => setLoading(false));
  }, [API]);

  const cardCls = isDark ? "bg-slate-900/60 border-slate-800" : "bg-white border-slate-200";

  return (
    <div className={`min-h-screen ${isDark ? "bg-slate-950 text-slate-100" : "bg-slate-50 text-slate-900"}`} data-testid="inflammation-twin-page">
      <MobileTopBar title="Възпаление" fallbackTo="/dashboard" testid="inflammation-twin-mobile-topbar" />
      <div className="max-w-3xl mx-auto p-4 sm:p-6">
        <button onClick={() => navigate("/dashboard")} className="text-xs opacity-60 hover:opacity-100 mb-3 flex items-center gap-1"><ArrowLeft className="w-3.5 h-3.5" /> Към таблото</button>
        <div className="flex items-center gap-2 mb-3">
          <Flame className="w-5 h-5 text-orange-500" />
          <h1 className="text-xl font-bold">{twinLabel("inflammation")}</h1>
        </div>
        <p className={`text-xs mb-4 ${isDark ? "text-slate-400" : "text-slate-600"}`}>Системно възпаление по hsCRP, съотношението неутрофили към лимфоцити и противовъзпалителното хранене. Качете PDF с резултати за автоматично попълване.</p>

        {loading ? <Loader2 className="w-6 h-6 animate-spin text-orange-500 mx-auto my-12" /> : (
          <div className={`p-5 rounded-2xl border-2 mb-4 ${cardCls}`} data-testid="inflammation-snapshot">
            <div className="flex items-baseline gap-3 mb-2">
              <span className="text-4xl font-bold" data-testid="inflammation-score">{snap?.composite ?? "—"}</span>
              <span className="text-xs opacity-60">/100</span>
              {snap?.hscrp_mg_l != null && (
                <span className="ml-auto text-xs px-2 py-1 rounded-md font-bold bg-orange-500 text-white" data-testid="hscrp-badge">hsCRP {snap.hscrp_mg_l} mg/L</span>
              )}
            </div>
            <p className="text-sm mt-2" data-testid="inflammation-interpretation">{snap?.interpretation_bg}</p>
            {snap?.sub_scores && (
              <div className="grid grid-cols-3 gap-2 mt-3 text-xs">
                {Object.entries(snap.sub_scores).map(([k, v]) => (
                  <div key={k} className={`p-2 rounded-lg text-center ${isDark ? "bg-slate-800/50" : "bg-slate-100"}`}>
                    <div className="opacity-60 text-[10px]">{k}</div>
                    <div className="font-bold">{v ?? "—"}</div>
                  </div>
                ))}
              </div>
            )}
            <Button onClick={() => navigate("/dashboard/lab-twin")} variant="outline" className="w-full mt-3" data-testid="goto-lab-btn">
              Качете PDF в лабораторните изследвания
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
